import type { ProviderStatus } from "../types.js";

/**
 * Pure label/format helpers for the AI Providers panel, extracted from
 * `ProvidersPanel.tsx` so they unit-test directly.
 */

/** The display label for a provider id, falling back to the raw id. */
export function labelFor(status: ProviderStatus, id: string): string {
  return status.providers.find((p) => p.id === id)?.label ?? id;
}

/** A friendly name for a provider key used in the role/spend breakdowns. */
export function providerLabel(p: string): string {
  if (p === "openai") return "OpenAI";
  if (p === "anthropic") return "Anthropic (Claude)";
  if (p === "deepseek") return "DeepSeek";
  return p;
}

/** USD formatting: 2 decimals (with thousands separators) at $1+, else 4
 * decimals so sub-cent metered spend is still legible. */
export function formatUsd(n: number): string {
  if (n >= 1) {
    return `$${n.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  }
  return `$${n.toFixed(4)}`;
}
